module.exports = __webpack_public_path__ + "static/media/ncbr_resized.0eccc96e.png";